import Vue from 'vue'
import path from 'path'

let modules = require.context('', true, /.vue$/);
modules.keys().forEach(key => {
    const config = modules(key).default
    const name = path.basename(key, path.extname(key))
    name != 'index' && Vue.component(name, config)

})